import React from 'react'
import { Container } from 'react-bootstrap'
import styled from 'styled-components'
import { Link } from 'gatsby'

class Seo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            padding: 50px 0 100px 0;
            background-color: #fff;            
        `

        const Overlay = styled.div`
            width: 100%;
            display: block;
            align-items: center;
            background-color: rgba(255,255,255);
            
            @media (min-width:768px) and (max-width:1500px) {
                
            }
            @media (max-width:767px) {
                             
            }
        `

        const Heading2 = styled.h2`
            font-size: 60px;
            font-family: Poppins;
            line-height: 60px;
            color: #4285f4;
            font-weight: bold;
            text-transform: uppercase;
            text-align: center;
            @media (min-width:768px) {
                margin-left: 4px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 70px;
                line-height: 70px;
            }
            @media (max-width:767px) {
                font-size: 40px;
                line-height: 40px;
                margin-left: 2px;
            }
        `

        const Heading3 = styled.h3`
            font-size: 40px;
            font-family: Poppins;
            line-height: 40px;
            color: #000;
            font-weight: 700;
            margin-top: 50px;
            text-align: center;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #4285f4, #e34133);
            background: -o-linear-gradient(right, #4285f4, #e34133);
            background: -moz-linear-gradient(right, #4285f4, #e34133);
            background: linear-gradient(to right, #4285f4, #e34133); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 40px;
            }
        `
        const Heading3a = styled.h3`
        font-size: 40px;
        line-height: 40px;
        font-family: "Montserrat", sans-serif;        
        font-weight: bold;
        text-align: center; 
        margin-top: 80px;       
        @media (min-width:768px) and (max-width:1600px) {
          font-size: 40px;
          line-height: 40px;
        }
        @media (max-width:767px) {
          font-size: 30px;
          line-height: 30px;          
        }
        ` 
        const Headinga = styled(Link)`        
        color: #78c91c;
        transition: .5s;
          &:hover {
            color: #000;
            text-decoration: none;
          }
        `      
        
        const Content = styled.div`
            position: relative;
            z-index: 10;
            margin-top: 100px;
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #4285f4;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `
        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #4a4949;
        `
        
        return (
                <Section id="home">
                    <Overlay>
                        <Container>
                            <Content>
                                <Heading2>
                                ¡Optimiza tu presencia en línea hoy mismo!
                                </Heading2>
                                <Heading3>
                                Expertos en maximizar tu visibilidad en línea
                                </Heading3>
                                <Separator/>
                                <Text>
                                Obtén una auditoría detallada de tu sitio web, identifica áreas de mejora y lleva tu estrategia SEO al siguiente nivel
                                 con nuestros servicios de análisis, auditoría y optimización. 
                                </Text>
                                <Text>
                                ¡Potencia tu visibilidad en los motores de búsqueda y alcanza tus objetivos de negocio ahora!
                                </Text>                                
                                <Heading3a>
                                <Headinga to="/conecta">
                                ¡Mejora mi SEO ahora!
                                </Headinga>
                                </Heading3a>                                
                            </Content>
                        </Container>
                    </Overlay>                    
                </Section>
        )
    }
}
export default Seo